import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from '../../../hooks/auth';
import DefaultView from './DefaultView';
import api from '../../../services/api';
import { Container, ShimmerBackPage, ShimmerCardHeader, ShimmerCardDivider, ShimmerCardTable, SkeletonCard } from './styles';
import { PurchaseData } from './types';

const UserFinance = () => {
  const { user } = useAuth();
  const [purchases, setPurchases] = useState<PurchaseData>({
    cartid: '',
    data: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const getPurchases = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await api.get(`/user/myproducts/payments?userid=${user.userid}&page=0`);
      console.log('called default req Purchases response', response);

      setPurchases(prevState => ({
        ...prevState,
        cartid: response.data.payments[0].cartid,
        data: response.data.payments,
      }));
    } catch (error) {
      console.log('error', error);
      const errorMessage = 'Erro ao carregar suas compras. Tente novamente.';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [user.userid]);

  useEffect(() => {
    const handleFetchData = async () => {
      await getPurchases();
    };

    handleFetchData();
  }, [getPurchases]);

  const renderSkeletons = () => (
    <>
      <ShimmerBackPage />
      {[1, 2].map(i => (
        <SkeletonCard key={i}>
          <ShimmerCardHeader />
          <ShimmerCardDivider />
          <ShimmerCardTable />
        </SkeletonCard>
      ))}
    </>
  );

  return loading ? (
    <Container>{renderSkeletons()}</Container>
  ) : (
    <DefaultView onRefresh={getPurchases} purchases={purchases.data} error={error} />
  );
};

export default UserFinance;
